import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Icon from '../Shared/Icon';
import Title from '../Shared/Title';

const Option = props => (
    <Grid container>
        <Icon system={props.SystemKey} />
        {props.Name}
    </Grid>
)

const FormSelectSystems = props => {
    const sysconfig = useSelector(state => state.sysconfig)
    const selected = sysconfig.data ? sysconfig.data.find(x => x.SystemKey === props.value) : {}
    const options = sysconfig.data ? sysconfig.data.filter(props?.filter || (() => true)) : []

    return (
        <FormControl variant='standard' fullWidth>
            <InputLabel>System</InputLabel>
            <Select
                name="SystemKey"
                variant="standard"
                value={props.value || ''}
                onChange={props.handler}
                renderValue={() => <Option {...selected} />}
                className="SelectSystems"
            >
                {options.length > 0 && options.map((option, key) => {
                    return (
                        <MenuItem
                            key={key}
                            value={option.SystemKey}
                            className="Option"
                        >
                            {/* <Option {...x} /> */}
                            <Title
                                row
                                systems={[option.SystemKey]}
                                label={option.Name}
                            />
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

export default FormSelectSystems;